import * as React from 'react'
import {connect} from "react-redux"
import {ApplicationState} from "../../store"
import {Button} from "@material-ui/core"
import SaveIcon from "@material-ui/icons/Save"
import BaseTab, {BaseTabProps, BaseTabState} from "../BaseTab"
import {actionNotificationSave, actionNotificationFetch} from "../../store/notifications/actions"
import {actionActiveTabTitle} from '../../store/tabs/actions'
import {Tab} from '../Tab'
import {Validator} from '../../core/Validator'
import {NotificationDescriptor} from '../../models/Notification'
import {Utility} from '../../core/Utility'
import {t} from "../../core/localization"
import {User} from "../../models/User"
import {actionUserFetchAll} from "../../store/users"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {EntityField} from "../../core/genericdocuments/EntityField"
import {LookupDataRow} from "../../services/LookupDataRow"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {FieldView} from "../components/FieldView"
import {notificationFieldsDescriptor} from "./NotificationFields"

export interface NotificationTabProps extends BaseTabProps{
	tab: Tab
	users: User[]
}

export interface NotificationTabState extends BaseTabState{
	isDialogOpen: boolean,
	dialogTitle: string,
	dialogText: string,
	validation: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		state: state.tabs.active.state,
		item: state.tabs.active.item,
		tab: state.tabs.active,
		users: state.users.list
	}
}

class NotificationTab extends BaseTab<NotificationTabProps, NotificationTabState> {

	constructor(props: NotificationTabProps) {
		super(props)
		this.state = {isDialogOpen: false, dialogText: '', dialogTitle: '', validation: { valid: true, fields: [] }}
		actionUserFetchAll()
    }

	componentDidMount() {
		actionUserFetchAll()
		if (this.props.item && this.props.item.id) actionNotificationFetch(this.props.item)
	}

	componentWillReceiveProps(nextProps: NotificationTabProps) {
	}

	onDialogClose () {
		this.setState({ ...this.state, isDialogOpen: false})
	}

	render(): React.ReactNode {
		return (
			<div style={{padding: '20px'}}>
				{this.renderForm()}
				{this.renderControls()}
			</div>
		)
	}

	renderForm(): React.ReactNode {

		let descriptor: EntityFieldsDescriptor<any> = notificationFieldsDescriptor

		return (<div className="create-form">
		{
			descriptor && descriptor.createFormFields.map(
				(entityField: EntityField<any>, index: number) => {
					const fieldName = entityField.name.toString()
					let value = Utility.formatString(this.getItemFromTabState(fieldName))
					return (
						<div style={{ marginBottom: "0px", padding: "0px" }}>
							{<FieldView value={value}
									autoFocus={index === 0} field={entityField} formState={null}
									setFormState={null}
									handleInputChange={(fieldName, value) => this.handleItemGenericInputChange(fieldName, value)}
									validationState={this.state.validation}
									lookupData={this.getLookupData.bind(this)}
								/>}
							</div>
						)
					}
				)
			}
		</div>
		)
	}

	getLookupData(lookupEntity: LookupEntities): LookupDataRow[] {
		switch (lookupEntity) {
			case LookupEntities.Users: {
				return this.props.users.map((user: User) => {return {label: `${user.firstName} ${user.lastName}`, value: user.id, data: user}})
			}
		}
	}

	renderControls(): React.ReactNode {
		return <div style={{display: 'flex', flexDirection:'row-reverse'}}>
				<Button onClick={this.onSaveClick.bind(this)} variant="contained" color="primary" style={{}}><SaveIcon />{t.Save}</Button>
			</div>
	}

	onSaveClick () {
		let itemToSave = this.getItemFromTabState()
		itemToSave.seen = false

		let validation: any = Validator.validateItemWithErrorTypes(itemToSave, NotificationDescriptor)

		if (validation.valid) {
			actionNotificationSave(itemToSave)
			actionActiveTabTitle(t.Notification + ': ' + this.getItemFromTabState('title'))
		}
		this.setState({ ...this.state, validation: validation });
	}
}

export default connect(mapStateToProps)(NotificationTab)
